import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SCANNER_ID = "barcode-scanner-element";

const BarcodeScanner = ({ open, onClose, onScan }) => {
  const scannerRef = useRef(null);
  const [error, setError] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (!open) {
      setError(null);
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
        scannerRef.current = null;
      }
      return;
    }

    setStarting(true);
    setError(null);

    const scanner = new Html5Qrcode(SCANNER_ID);
    scannerRef.current = scanner;

    const config = {
      fps: 10,
      qrbox: { width: 300, height: 150 },
      formatsToSupport: [
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.ITF,
      ],
    };

    scanner
      .start(
        { facingMode: "environment" },
        config,
        (decodedText) => {
          onScan(decodedText);
          scanner.stop().catch(() => {});
          scannerRef.current = null;
          onClose();
        },
        () => {}
      )
      .then(() => {
        setStarting(false);
      })
      .catch((err) => {
        console.error("Barcode scanner error:", err);
        setError(
          err.toString().includes("NotAllowedError")
            ? "Permiso de cámara denegado. Por favor, habilita el acceso a la cámara."
            : "No se pudo iniciar la cámara. Verifica los permisos."
        );
        setStarting(false);
      });

    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Escanear código de barras
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        {starting && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Iniciando cámara...</Typography>
          </Box>
        )}
        <Box
          id={SCANNER_ID}
          sx={{
            width: "100%",
            minHeight: 300,
            display: starting ? "none" : "block",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BarcodeScanner;
